import { useEffect } from 'react';
import { hotjar } from 'react-hotjar';

export const useHotjar = () => {
  useEffect(() => {
    if (process.env.REACT_APP_CLIENT_ENVIRONMENT === 'prod' && !hotjar.initialized()) {
      const HJID = 3548557;
      const HJSV = 6;

      hotjar.initialize(HJID, HJSV);
    } else if (process.env.REACT_APP_CLIENT_ENVIRONMENT === 'dev' && !hotjar.initialized()) {
      const HJID = 3548562;
      const HJSV = 6;

      hotjar.initialize(HJID, HJSV);
    }
  }, []);
};
